if(!customElements.get('pdp-pre-add-modal')) {
  class ComponentPdpPreAddModal extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('.close-modal');
      this.addToCartBtn = this.querySelector('.pre-add-atc');

      this.productMainSection = document.querySelector('product-main.product-main-element');

      var productBtns = this.productMainSection.querySelector('product-buttons');
      this.addMulberryBtn = productBtns.querySelector('.mulberry-add');
      this.mainAtc = productBtns.querySelector('.btn.add');

      this.addonInputs = this.productMainSection.querySelectorAll('input[data-name]:not(.addon-qtty)');

      if(this.dataset.addonTarget && this.dataset.addonTarget != ''){
        this.addonToInclude = this.productMainSection.querySelector(`#${this.dataset.addonTarget}`);
        this.addonParent = this.querySelector('.addon-parent');

        
        if(this.addonToInclude){
          this.replicateAddon();
          this.addAddonMutation();
        }

        this.addonInputs.forEach(input => {
          input.addEventListener('change', () => {
            this.checkaddonInputs();
          });
        });
      }

      this.addMutationCallback();
    
      if(this.closeBtn){
        this.closeBtn.addEventListener('click', ()=>{
          $s.closeModal();
        })
      }

      if(this.addToCartBtn){
        this.addToCartBtn.addEventListener('click', ()=>{
          if(this.addMulberryBtn && this.addMulberryBtn.style.display == 'none')
            this.mainAtc.click();
          else
            this.addMulberryBtn.click();
          $s.closeModal();
        })
      }
      

    }

    addAddonMutation(){
      const mutationCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
              this.replicateAddon();
            }
          }
      };
      const observer = new MutationObserver(mutationCallback);

      observer.observe(this.addonToInclude, { subtree: true, childList: true }); 

    }

    replicateAddon(){
      const addonMainInput = this.addonToInclude.querySelector('input[data-name]:not(.addon-qtty)');
      const addonCheckoxCustom = this.addonToInclude.querySelector('.checkbox-custom');
      const addonSelect = this.addonToInclude.querySelector('select');
      const target = this.addonParent.querySelector('.addon-target');

      if(addonMainInput){
        this.addonParent.classList.remove('hide');
        target.innerHTML = '<div class="checkbox-target"></div><div class="select-target hide"></div>'
        const selectTarget = target.querySelector('.select-target')

        const selectElement = document.createElement('select');
        const checkboxElement = document.createElement('input');
        checkboxElement.type = 'checkbox';
        checkboxElement.id = 'pre-add-popup-input'; 
        checkboxElement.classList.add('checkbox-custom');
        checkboxElement.addEventListener('change', (event)=>{
          addonCheckoxCustom.checked = event.currentTarget.checked;
          addonCheckoxCustom.dispatchEvent(new Event('change'));
          if(event.currentTarget.checked){
            selectTarget.classList.remove('hide');
          } else {
            selectTarget.classList.add('hide');
          }
        });

        const labelCheckboxElement = document.createElement('label');
        labelCheckboxElement.htmlFor = 'pre-add-popup-input'; 
        labelCheckboxElement.textContent = this.dataset.addonLabel;
        labelCheckboxElement.classList.add('checkbox-custom-label');

        const chexboxTarget = target.querySelector('.checkbox-target');
        chexboxTarget.appendChild(checkboxElement);
        chexboxTarget.appendChild(labelCheckboxElement);

        if(addonSelect){      
          var optionsHtml = '';

          addonSelect.querySelectorAll('option').forEach(option => {
            const newOption = document.createElement('option');
            newOption.value = option.value;
            newOption.textContent = option.innerHTML;
            selectElement.appendChild(newOption);
          });

          selectElement.addEventListener('change',(event)=>{
            const inputAddon = addonMainInput;
            inputAddon.value = event.target.value;
            addonSelect.value = event.target.value;
          })

          selectTarget.appendChild(selectElement);
        }
      }
      
    }

    addMutationCallback(){

      const mutationCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "attributes") {
              this.checkaddonInputs();
            }
          }
      };
      const observer = new MutationObserver(mutationCallback);

      this.addonInputs.forEach(addonInput => {
        observer.observe(addonInput, { attributes: true }); 
      });

    }

    checkaddonInputs(){

      if(this.productMainSection.dataset.productAbsentToAddModal){
        var variantsToMatch = this.productMainSection.dataset.productAbsentToAddModal.split(',');

        var hideButtonModal = false;

        this.addonInputs.forEach(addonInput => {
          if(addonInput.hasAttribute('name')){
            if( variantsToMatch.includes(addonInput.value)){
              hideButtonModal = true;
            }            
          }

        });


        if(hideButtonModal){
          this.productMainSection.querySelector('.open-modal-add').classList.add('hide');
          this.productMainSection.querySelector('.add-btns').classList.remove('hide');
        }
        else{
          this.productMainSection.querySelector('.open-modal-add').classList.remove('hide');
          this.productMainSection.querySelector('.add-btns').classList.add('hide');
        }

      }
    }


  }
  customElements.define('pdp-pre-add-modal', ComponentPdpPreAddModal);
}